import { AnchorButton, Icon } from '@blueprintjs/core';
import { IconName, IconNames } from '@blueprintjs/icons';
import * as React from 'react';

export interface ExpressionCascadeButtonProps {
  hoverIcon: IconName;
  iconColor?: string;
  testId: string;
  onClick: () => void;
}

export const ExpressionCascadeButton: React.VFC<
  ExpressionCascadeButtonProps
> = ({ hoverIcon, iconColor, testId, onClick }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  return (
    <AnchorButton
      className="sd-query-builder-expression-cascade-button"
      data-testid={testId}
      icon={
        <Icon
          color={iconColor}
          icon={isHovered ? hoverIcon : IconNames.CIRCLE_ARROW_RIGHT}
        />
      }
      minimal
      onClick={onClick}
      onMouseOut={() => setIsHovered(false)}
      onMouseOver={() => setIsHovered(true)}
    />
  );
};
